// Inicia os observers
init();

// imagem principal
function init() {
  initObserver("img.__lazy_loading");
}

// Eventos de Hover / carrossel
const loadSecondaryImages = () => {
  // Executa a lógica original
  if (window.innerWidth >= 768) {
    initObserver("img.__lazy_hover");
  } else {
    initObserver("img.__lazy_carrossel_image");
  }

  // Remove os ouvintes para rodar apenas uma vez
  ['scroll', 'touchstart', 'click'].forEach(evt => 
    window.removeEventListener(evt, loadSecondaryImages)
  );
};

// Adiciona os gatilhos de interação (usei passive: true para performance)
['scroll', 'touchstart', 'click'].forEach(evt => 
  window.addEventListener(evt, loadSecondaryImages, { passive: true })
);


function initObserver(selector) {
  const imgs = document.querySelectorAll(selector);
  if (!imgs.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadWithSizes(entry.target);
        observer.unobserve(entry.target);
      }
    });
  });

  imgs.forEach(img => observer.observe(img));
}

function loadWithSizes(img) {
  const srcset = img.getAttribute('data-srcset');
  
  if (srcset) {
    const elementWidth = Math.ceil(img.getBoundingClientRect().width);
    img.setAttribute('sizes', `${elementWidth}px`);

    const onImageLoaded = () => {
      img.classList.remove('__lazy_loading', '__lazy_carrossel_image', 'invisible');
      img.setAttribute('loaded', '') // Adiciona o atributo que libera a visualização
      img.removeEventListener('load', onImageLoaded); // Remove o listener para limpar memória
    }

    img.addEventListener('load', onImageLoaded);

    // Dispara o download
    img.srcset = srcset;
    img.removeAttribute('data-srcset');

    // Verificação de segurança: Se a imagem já estiver em cache, o evento load pode não disparar
    if (img.complete && img.naturalWidth > 0) {
      onImageLoaded();
    }
  }
}